<mat-card class="card" [ngClass]="{ expanded: show }">
  <div class="card-content">
    <div class="card-header" [ngClass]="classText(transactionType)">
      <div class="card-main">
        <div class="number-container">
          {{ returnTransactionType(transactionType) }}{{ quantity | number:'': language}}
        </div>
        <div class="transaction-type-container">
          <mat-icon class="icon">{{ returnIconType(transactionType) }}</mat-icon>
          <span class="type-name">{{ formatTransactionTypeName(transactionType) }}</span>
        </div>
      </div>
      <div class="expired-label add" *ngIf="isExpireTransaction(transactionType)">
        {{ transactionLabels.expiredLabel}} {{ generationDate | date: dateFormat : 'UTC' : language}}
      </div>
      <div class="expires-text add" *ngIf="isAddTransaction(transactionType) && expirationDate">
        {{transactionLabels.expiresFrom}} {{expirationDate | date: dateFormat : 'UTC' : language}}
      </div>
    </div>

    <div class="buttons-area">
      <button *ngIf="transactionType !== transactionTypes.PORT" mat-button class="button" (click)="toggleShow()" id="lnr-expand-transaction-card">
        <mat-icon>{{ show ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
  </div>

  <app-transaction-card-expanded
    *ngIf="show && !errorExpanded"
    [transactions]="transactions"
    [sum]="quantity"
    [loadingTransaction]="loadingTransaction"
    [codesLabel]="codesLabel"
  ></app-transaction-card-expanded>
  <app-label message
  isError
  *ngIf="show && errorExpanded"
  class="error-label">
  {{transactionLabels.transactionError}}
</app-label>
  <div class="footer" *ngIf="show && !errorExpanded" [ngClass]="classText(transactionType)">
    <div class="footer-info">
    <span *ngIf="footerPrefix; else onlyDate">
      {{ footerPrefix }} {{ transactionLabels.onLabel }}
      {{ generationDate | date: dateFormat : 'UTC' : language }}
    </span>

      <ng-template #onlyDate>
        {{ transactionLabels.onLabel }}
        {{ generationDate | date: dateFormat : 'UTC' : language }}
      </ng-template>
    </div>
  </div>
</mat-card>
